module.exports = "https://bin.bnbstatic.com/_next/static/images/chz-banner-en-02945676d98f240d856d1be091303df3.jpg";